// Whether a review card may show a star rating.
//
// The stored reviews were transcribed from a listing crawl whose columns were
// avatar, name, review count, relative time, text and owner response — no star
// ratings. Those rows were written with `rating: 5`, so the section displayed a
// five-star rating that no source had reported. The rule is that a card shows
// stars only when a rating was actually observed (ASAP-RVS-007).
//
// Exported from here rather than inlined in the component so it can be tested:
// this project has no React test renderer.

/** A rating has to be a whole number of stars in Google's 1–5 range. */
export function hasConfirmedRating(value) {
  if (value === null || value === undefined || value === '') {
    return false;
  }

  // Reject by type before coercing. `Number(true)` is 1 and `Number([])` is 0,
  // so a loose Number() coercion would happily render a boolean as one star and
  // an array as none. Only a number, or a string that is entirely a number, is a
  // rating at all.
  const isNumeric = typeof value === 'number' || typeof value === 'string';

  if (!isNumeric) {
    return false;
  }

  // A string must be a complete number, not '4 stars'.
  if (typeof value === 'string' && !/^\d+(\.\d+)?$/.test(value.trim())) {
    return false;
  }

  const rating = Number(value);

  return Number.isInteger(rating) && rating >= 1 && rating <= 5;
}